import {
  // MailOutlined,
  // AppstoreOutlined,
  // SettingOutlined,
  UsergroupDeleteOutlined,
  ScanOutlined,
  SaveOutlined,
  DashboardOutlined,
  ReconciliationOutlined,
  ContainerOutlined,
  TransactionOutlined,
} from "@ant-design/icons";
export const sideBarMenuItemsList = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashboardOutlined,
    protected: true,
    subItems: [],
  },
  {
    path: "/dashboard/users",
    name: "Users",
    icon: UsergroupDeleteOutlined,
    protected: true,
    subItems: [],
  },
  {
    path: "/dashboard/savings",
    name: "Savings",
    icon: SaveOutlined,
    protected: true,
    subItems: [],
  },
  // {
  //   path: "/dashboard/investments",
  //   name: "Investments",
  //   icon: ReconciliationOutlined,
  //   protected: true,
  //   subItems: [],
  // },
  {
    path: "/dashboard/transactions",
    name: "Transactions",
    icon: TransactionOutlined,
    protected: true,
    subItems: [],
  },
  {
    path: "/dashboard/loans",
    name: "Loans",
    icon: ReconciliationOutlined,
    protected: true,
    subItems: [],
  },

  //,

  // { redirect: true, path: "/", to: "/dashboard", name: "Dashboard" }
];
